/**
 * MLD-4934
 */
export default {
  getVisibilityState() {
    return document.visibilityState;
  },
  isTabVisible() {
    return this.getVisibilityState() === 'visible';
  },
  hasFocus() {
    return document.hasFocus();
  },
}
